module.exports = __webpack_public_path__ + "static/1_SUPERSINGLE-0b17403841cdd132bd408b1b7f916c93.png";